<span class="relative inline-flex align-items-center">
  <button type="button" class="p-0 border-none bg-transparent cursor-pointer flex align-items-center"
    (click)="toggle(); $event.stopPropagation()">
    <i class="pi pi-info-circle text-color-secondary text-sm"></i>
  </button>
  @if (isVisible) {
    <div class="info-popover-panel absolute z-5 bg-white border-1 border-round shadow-2 p-3"
      (click)="$event.stopPropagation()">
      <div class="flex align-items-center justify-content-between mb-2">
        <span class="font-semibold">{{ header }}</span>
        <button type="button" class="p-0 border-none bg-transparent cursor-pointer text-color-secondary flex align-items-center"
          (click)="close()">
          <i class="pi pi-times"></i>
        </button>
      </div>
      <div class="text-sm text-color-secondary line-height-3">
        <ng-content></ng-content>
      </div>
    </div>
  }
</span>